import { FC, useContext, useState } from "react";
import NotificationDispatch, { showErrorNotification } from "../../context/notificationContext";
import { useI18n } from "../../hooks/useTranslations";
import { useMaintenancesApi } from "../../http/maintenances/api";
import ModalDialog from "../ui/ModalDialog";

type DeleteMaintenanceDialogProps = {
  maintenanceId: string;
  carId: string;
  onClose: (success?: boolean) => void;
};

const DeleteMaintenanceDialog: FC<DeleteMaintenanceDialogProps> = ({
  maintenanceId,
  carId,
  onClose,
}) => {
  const i18n = useI18n();
  const maintenancesApi = useMaintenancesApi();
  const dispatch = useContext(NotificationDispatch);
  const [isSubmitting, setIsSubmitting] = useState(false);

  return (
    <ModalDialog
      onClose={() => onClose()}
      title={i18n.t.maintenance.delete}
      isSubmitting={isSubmitting}
      actions={[
        {
          title: i18n.t.common.cancel,
          type: "secondary",
          onClick: () => onClose(),
        },
        {
          title: i18n.t.common.yes,
          onClick: () => {
            setIsSubmitting(true);
            maintenancesApi
              .deleteAdminMaintenance(maintenanceId, carId)
              .then(() => onClose(true))
              .catch((err) => dispatch(showErrorNotification(i18n, err)))
              .finally(() => setIsSubmitting(false));
          },
        },
      ]}
    >
      {i18n.t.maintenance.questions.delete}
    </ModalDialog>
  );
};

export default DeleteMaintenanceDialog;
